export default "__VITE_ASSET__BRItNX0a__"